import React from 'react';

//mobx
import { observer } from 'mobx-react-lite';
import { Video } from '@/components';

const App = ({ url }) => {


    return (
        <>
            <Video url={url} forceHLS={true} />
        </>
    )
}
export default observer(App)